import { ContentSpacing } from '@estee/elc-base-theme';

export interface IColors {
  [key: string]: string;
}

export interface IFonts {
  [key: string]: string;
}

export interface ISpacings {
  [key: string]: {
    [key: string]: string;
  };
}

export interface ITheme {
  colors: IColors;
  fonts: IFonts;
  spacings: ISpacings;
}

/* eslint-disable sort-keys */
const defaultTheme: ITheme = {
  colors: {
    // TODO cleanup these once all other regional css are moved to vulcan
    primary800: '#424242',
    primary300: '#E0E0E0',
    primary200: '#EEEEEE',
    primary100: '#F5F5F5',
  },
  fonts: {
    'main-font-family': '"Helvetica Neue LT Pro", sans-serif',
    'header-font-family': '"Helvetica Neue LT Pro", sans-serif',
  },
  spacings: {
    // Since we are mobile first the default = mobile
    default: {
      'container-padding-top': ContentSpacing.space24,
      'container-padding-right': ContentSpacing.space16,
      'container-padding-bottom': ContentSpacing.space24,
      'container-padding-left': ContentSpacing.space16,
      'container-space-between': ContentSpacing.space24,
      'grid-column-space': '0',
      'order-summary-margin-bottom': '15px',
      'delivery-screen-tab-padding': ContentSpacing.space16,
      'billing-address-title-margin-bottom': ContentSpacing.space24,
      'form-column-fields-gap': ContentSpacing.space10,
      'form-row-fields-gap': ContentSpacing.space16,
    },
    desktop: {
      'container-padding-top': ContentSpacing.space24,
      'container-padding-right': ContentSpacing.space16,
      'container-padding-bottom': ContentSpacing.space24,
      'container-padding-left': ContentSpacing.space16,
      'container-space-between': ContentSpacing.space24,
      'grid-column-space': '38px',
      'delivery-screen-tab-padding': ContentSpacing.space16,
      'billing-address-title-margin-bottom': ContentSpacing.space24,
      'form-column-fields-gap': ContentSpacing.space20,
      'form-row-fields-gap': ContentSpacing.space24,
    },
  },
};

export default defaultTheme;
